export default "__VITE_ASSET__71ee4f1c__"